<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12" v-show="isLoading">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status" >
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

            </div>
        </div>
        <div class="row ">

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--<h4 class="card-title mb-4">Registro de socios</h4>-->

                        <form @submit="formSubmit">
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Nombre</label>
                                <div class="col-sm-9">
                                    <input class="form-control" type="text"   v-model="model.name" placeholder="Ingrese el nombre"  required />
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Permisos</label>
                                <div class="col-sm-9">
                                    <v-select
                                            :options="permisos"
                                            v-model="model.permissions"
                                            aria-placeholder="Selecione"
                                            :multiple="true"
                                            label="name"
                                            required>
                                    </v-select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-7 offset-md-3">
                                    <button type="submit" class="btn btn-sm btn-primary m-r-5" :disabled='isLoading' > {{ this.isLoading?'Guardando...':'Guardar' }}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>





</template>

<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import PageHeader from "@/components/page-header";


    export default {



        page: {
            title: "Roles",
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: {
            Layout,
            PageHeader,
        },
        name: "Roles-formulario",
        data(){
            return {
                title: "Roles",
                items: [
                    {
                        text: "Administración",
                        href: "/",
                    },
                    {
                        text: "Roles",
                        active: true,
                    },
                ],
                roles:[],
                errorPasswordNotEqual:false,
                isLoading:false,
                model: {

                },
                output:"",
                permisos:[],
            }
        },
        methods:
            {
                resetError()
                {
                    this.errorPasswordNotEqual=false

                },
                formSubmit(e) {
                    e.preventDefault();
                    if(this.model.password!==this.model.password2)
                    {
                        this.errorPasswordNotEqual=true;
                        return;
                    }
                    //let currentObj = this;
                    this.isLoading=true;
                    this.axios.post(process.env.VUE_APP_BACKEND + '/api/roles', this.model)
                        .then((response) =>{
                            if(response.data.success)
                            {
                                this.$swal('Ok',response.data.mensaje,'success');
                                this.$router.push('/administracion/roles');
                            }
                        })
                        .catch((error) =>{
                            if (error.response) {

                                this.$swal('Error',error.response.data.mensaje,'warning');
                            }
                            else
                            {
                                this.$swal('Error',"Server error",'error');
                            }

                        })
                        .finally(()=>this.isLoading=false);
                }
            },
        mounted() {
            if(!isNaN(this.$route.params.id))
            {
                //console.log(this.$parent);
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + '/api/roles/'+this.$route.params.id)
                    .then( (response)=>
                    {
                        this.model=response.data;
                        this.isLoading=false

                    }).finally(()=>this.isLoading=false);
            }
            else
            {
                this.roles={
                    'name':''
                };


            }
            this.axios.get(process.env.VUE_APP_BACKEND + '/api/permisos')
                .then(response=>{
                    this.permisos=response.data;
                });

        }
    }
</script>

<style scoped>

</style>
